import vue from 'vue'
import {apolloClient} from '@/graphql/apolloWrapper'
import {VODSET_CREATE_RAW} from "../../graphql/mutations/vodsets/create";
import {VODSET_DELETE} from "../../graphql/mutations/vodsets/delete";
import {VODSET_UPDATE_POSITIONS} from "../../graphql/mutations/vodsets/updatePositions";
import {GET_ALL_VODSETS} from "../../graphql/queries/vodsets/all";
import FormData from 'form-data'
import axios from 'axios'

const state = {
  uploading: false,
  uploadProgress: 0,
  vodsets: [],
};

const getters = {
  vodsetsAll: state => state.vodsets,
  vodsetUploading: state => state.uploading,
  vodsetUploadProgress: state => state.uploadProgress,
};

const mutations = {
  UPDATE_VODSET_LIST (state, vodsets) {
    vodsets.forEach(vodset => {
      state.vodsets.upsert({id: vodset.id}, vodset)
    })
  },
  UPDATE_VODSET_UPLOAD_PROGRESS (state, progress) {
    state.uploadProgress = progress;
  },

  UPDATE_VODSET_UPLOADING (state, uploading) {
    state.uploading = uploading;
  },
  UPDATE_VODSET_POSITIONS (state, positions) {
    for (const [position, id] of Object.entries(positions)) {
      let vodset = state.vodsets.find(item => item.id === id);
      if (vodset) {
        vodset.priority = position;
        state.vodsets.upsert({id: vodset.id}, vodset)
      }
    }
  },
  CREATE_VODSET (state, vodset) {
    state.vodsets.upsert({id: vodset.id}, vodset)
  },
  DELETE_VODSET (state, id) {
    state.vodsets = state.vodsets.filter(vodset => vodset.id !== id)
  }
};

const actions = {
  async vodsetCreate ({commit, dispatch}, file) {
    const token = localStorage.getItem('auth-token');
    let formData = new FormData()
    formData.append('operations', JSON.stringify({query: VODSET_CREATE_RAW, variables: {file: null}}))
    formData.append('map', JSON.stringify({'0': ['variables.file']}))
    formData.append(0, file, file.name)
    // console.log('putting in context token: ' + token)

    commit('UPDATE_VODSET_UPLOADING', true)
    try {
      let {data} = await axios.post(process.env.GRAPHQL_ENDPOINT, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
        onUploadProgress: progressEvent => {
          const progress = (progressEvent.loaded / Math.max(progressEvent.total, 1)) * 100;
          commit('UPDATE_VODSET_UPLOAD_PROGRESS', progress)
        }
      })

      data = data.data;
      if (data && data.vodsetCreate) {
        commit('CREATE_VODSET', data.vodsetCreate)
      }
    } catch (e) {
      dispatch('setErrorMessages', [e.message])
    }
    commit('UPDATE_VODSET_UPLOADING', false)
    commit('UPDATE_VODSET_UPLOAD_PROGRESS', 0)
    // console.log(res)

    // const {data} = await apolloClient.mutate({
    //   mutation: VODSET_CREATE,
    //   variables: {file},
    //   context: {hasUpload: true}
    // });

    // if (data && data.channelsUpdate) {
    //   commit('UPDATE_CHANNEL_LICENSE', {
    //     licenseId: input.licenseId,
    //     channelIds: input.channels
    //   });
    // }
  },
  async vodsetFetchList ({commit}) {
    const {data} = await apolloClient.query({query: GET_ALL_VODSETS});
    if (data && data.vodsetList) {
      commit('UPDATE_VODSET_LIST', data.vodsetList);
    }
  },
  async vodsetDeleteById ({commit}, id) {
    const {data} = await apolloClient.mutate({mutation: VODSET_DELETE, variables: {id: id}});
    if (data && data.vodsetDelete) {
      commit('DELETE_VODSET', id);
    }
  },
  async vodsetUpdatePositions ({commit}, positions) {
    const {data} = await apolloClient.mutate({
      mutation: VODSET_UPDATE_POSITIONS,
      variables: {positions: JSON.stringify(positions)}
    });

    if (data && data.vodsetUpdatePositions) {
      commit('UPDATE_VODSET_POSITIONS', positions);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vodsets.js